/* ==========================================================================
   Glomax B2B — Comportamiento del tema

   Diferencia importante respecto a la maqueta: el gating de precios YA NO
   está acá. Lo resuelve Liquid en el servidor con
   {% render 'b2b-can-see-price' %}, así que el precio de un cliente sin
   sesión nunca llega al HTML. La maqueta lo simulaba con JavaScript solo
   para poder revisar los dos estados en local.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Utilidades
     ------------------------------------------------------------------ */
  function money(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'es-CL', {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency
        ? window.Shopify.currency.active
        : 'CLP',
      maximumFractionDigits: 0
    }).format(cents / 100);
  }

  function on(root, selector, event, handler) {
    root.querySelectorAll(selector).forEach(function (el) {
      el.addEventListener(event, handler);
    });
  }

  /* ------------------------------------------------------------------
     1. Selector de cantidad
     Respeta el múltiplo de venta (step) y el pedido mínimo (min), que
     vienen de metafields del producto renderizados en el HTML.
     ------------------------------------------------------------------ */
  function initQuantity(scope) {
    (scope || document).querySelectorAll('.g-qty').forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';

      var input = wrap.querySelector('input');
      var buttons = wrap.querySelectorAll('button');
      if (!input || buttons.length < 2) return;

      var step = parseInt(input.step, 10) || 1;
      var min = parseInt(input.min, 10) || 0;

      function bump(delta) {
        var value = (parseInt(input.value, 10) || min) + delta * step;
        input.value = Math.max(min, value);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      buttons[0].addEventListener('click', function () { bump(-1); });
      buttons[1].addEventListener('click', function () { bump(1); });

      input.addEventListener('change', function () {
        var value = parseInt(input.value, 10);
        if (isNaN(value) || value < min) {
          input.value = min;
          return;
        }
        var rounded = Math.round(value / step) * step;
        if (rounded !== value) input.value = rounded;
      });
    });
  }

  /* ------------------------------------------------------------------
     2. Tabs accesibles
     Se usa en los carruseles de la home y en la ficha de producto.
     ------------------------------------------------------------------ */
  function initTabs(scope) {
    (scope || document).querySelectorAll('[role="tablist"]').forEach(function (list) {
      if (list.dataset.ready) return;
      list.dataset.ready = '1';

      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));

      function select(tab) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', String(on));
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }

      /* Cualquier enlace de la pagina que apunte a un panel oculto —o a algo
         dentro de el— abre primero su pestana. Sin esto, «Ver ficha tecnica
         completa» salta a un elemento con `hidden` y no pasa nada. */
      document.addEventListener('click', function (e) {
        var link = e.target.closest && e.target.closest('a[href^="#"]');
        if (!link) return;
        var id = link.getAttribute('href').slice(1);
        if (!id) return;
        var target = document.getElementById(id);
        if (!target) return;
        var panel = target.closest('[role="tabpanel"]');
        if (!panel || !panel.hidden) return;
        var owner = tabs.filter(function (t) {
          return t.getAttribute('aria-controls') === panel.id;
        })[0];
        if (owner) select(owner);
      });

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab); });

        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft')  next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home')       next = tabs[0];
          if (e.key === 'End')        next = tabs[tabs.length - 1];
          if (next) {
            e.preventDefault();
            next.focus();
            select(next);
          }
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     3. Escala activa en la ficha de producto
     Resalta el tramo que corresponde a la cantidad escrita. Es solo una
     señal visual: el descuento real lo aplica el motor de precios.
     ------------------------------------------------------------------ */
  function initTierHighlight() {
    var table = document.querySelector('[data-tiers]');
    var input = document.querySelector('.g-buybox__actions input[type="number"]');
    if (!table || !input) return;

    var rows = Array.prototype.slice.call(table.querySelectorAll('tbody tr'));

    function refresh() {
      var qty = parseInt(input.value, 10) || 0;
      var active = null;

      rows.forEach(function (row) {
        row.removeAttribute('data-active');
        var from = parseInt(row.dataset.from, 10);
        if (!isNaN(from) && qty >= from) active = row;
      });

      if (active) active.setAttribute('data-active', '');
    }

    input.addEventListener('change', refresh);
    input.addEventListener('input', refresh);
    refresh();
  }

  /* ------------------------------------------------------------------
     3b. Atajo de la escala por volumen
     Tocar un tramo pone su cantidad en el selector de la misma tarjeta.
     Delegado en el documento porque las tarjetas se repintan al filtrar y
     un oyente por tarjeta se perderia en cada repintado.
     ------------------------------------------------------------------ */
  function initTierShortcut() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-tier-qty]');
      if (!btn) return;

      var box = btn.closest('.g-card, .g-row, .g-buybox');
      var input = box && box.querySelector('.g-qty input');
      if (!input) return;

      var want = parseInt(btn.dataset.tierQty, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      var step = parseInt(input.step, 10) || 1;

      /* El tramo puede no caer en el multiplo de venta: se sube al
         siguiente valido, nunca se baja. Pedir 5 donde el multiplo es 3
         seria un formulario invalido al enviar. */
      if (want < min) want = min;
      if (step > 1) {
        want = min + Math.ceil((want - min) / step) * step;
      }

      var max = parseInt(input.max, 10);
      if (!isNaN(max) && want > max) want = max;

      input.value = want;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.focus();
    });
  }

  /* ------------------------------------------------------------------
     4. Colección: vista lista o grilla
     El valor inicial lo decide el ajuste del tema; a partir de ahí manda
     la preferencia del usuario.
     ------------------------------------------------------------------ */
  function initViewToggle() {
    var toggle = document.querySelector('.g-viewtoggle');
    if (!toggle) return;

    var buttons = Array.prototype.slice.call(toggle.querySelectorAll('button'));

    function apply(view) {
      buttons.forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.dataset.view === view));
      });
      document.querySelectorAll('[data-viewpanel]').forEach(function (panel) {
        panel.hidden = panel.dataset.viewpanel !== view;
      });
      try {
        localStorage.setItem('glomax-view', view);
      } catch (e) { /* modo privado */ }
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.dataset.view); });
    });

    var saved = null;
    try {
      saved = localStorage.getItem('glomax-view');
    } catch (e) { /* modo privado */ }

    apply(saved || toggle.dataset.default || 'list');
  }

  /* ------------------------------------------------------------------
     3a. Ficha: la galeria
     Las miniaturas se dibujaban con `data-gallery-thumb` y la foto grande
     con `data-gallery-main`, pero no habia nada que los uniera: hacer clic
     no cambiaba la imagen. Esto es lo que faltaba.
     ------------------------------------------------------------------ */
  function initGallery(scope) {
    (scope || document).querySelectorAll('.g-gallery').forEach(function (gal) {
      if (gal.dataset.ready) return;
      var main = gal.querySelector('[data-gallery-main] img');
      var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-gallery-thumb]'));
      if (!main || !thumbs.length) return;
      gal.dataset.ready = '1';

      function show(thumb) {
        if (!thumb.dataset.src) return;

        /* El srcset se escribe ANTES que el src. Al reves, el navegador
           resuelve el src viejo contra el srcset nuevo y pinta un fotograma
           de la imagen anterior. */
        if (thumb.dataset.srcset) main.srcset = thumb.dataset.srcset;
        main.src = thumb.dataset.src;

        var small = thumb.querySelector('img');
        if (small && small.alt) main.alt = small.alt;

        thumbs.forEach(function (t) {
          t.setAttribute('aria-current', String(t === thumb));
        });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () { show(thumb); });

        /* Flechas para moverse entre miniaturas, como en cualquier lista de
           opciones. El foco viaja con la seleccion. */
        thumb.addEventListener('keydown', function (e) {
          var i = thumbs.indexOf(thumb);
          var next = null;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = thumbs[(i + 1) % thumbs.length];
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = thumbs[(i - 1 + thumbs.length) % thumbs.length];
          if (!next) return;
          e.preventDefault();
          next.focus();
          show(next);
        });
      });
    });
  }

  /* ------------------------------------------------------------------
     3c. Ficha: filas de dato con etiqueta
     Marca los <li> que ABREN con <strong>, que son los que traen un dato
     etiquetado —«Dimensiones: 224 x 100 cm»— y no una caracteristica.
     CSS no puede distinguirlos: `:first-child` ignora los nodos de texto, y
     daria por buena tambien «Elevacion de respaldo: <strong>0 a 75</strong>»,
     que es una frase con enfasis.
     ------------------------------------------------------------------ */
  var SPEC_RE = /^([^:.;,]{2,45}):\s+(\S.*)$/;

  function initSpecRows(scope) {
    (scope || document).querySelectorAll('.g-ficha li').forEach(function (li) {
      var n = li.firstChild;
      /* Los espacios y saltos de linea del HTML no cuentan como «texto
         delante»: el editor de Shopify los deja por todas partes. */
      while (n && n.nodeType === 3 && !n.textContent.trim()) n = n.nextSibling;
      if (n && n.nodeType === 1 && n.tagName === 'STRONG') {
        /* Solo si queda algo DESPUES de la negrita. Hay items con la frase
           entera en negrita —«Incluye Motor»— y como fila de dos columnas
           salian con la etiqueta puesta y el valor vacio: media fila en
           blanco en medio de la tabla. Esos se quedan como item. */
        var cola = li.textContent.slice(n.textContent.length).trim();
        if (cola) {
          li.classList.add('is-spec');
          return;
        }
      }

      /* La etiqueta se reconoce por los DOS PUNTOS, no por donde cayo la
         negrita.

         Las descripciones del catalogo las escribio una IA y puso las
         negritas donde quiso: en «Ciclo de inflado: 12 minutos» marco la
         etiqueta y en «Flujo de aire: 5-7 L/min» marco el valor. Son el
         mismo dato en la misma lista, y antes salian de dos formas
         distintas —fila de dos columnas el primero, item con check el
         segundo— porque la deteccion miraba la negrita. Eso es lo que se
         veia descuadrado en la ficha. */
      var m = li.textContent.trim().match(SPEC_RE);
      if (!m) return;

      /* El primer nodo con contenido. Si es texto y lleva los dos puntos,
         basta con partir ESE nodo: el resto del <li> —el <strong> sobre el
         valor, un enlace, lo que sea— se queda intacto donde esta. */
      if (n && n.nodeType === 3 && n.textContent.indexOf(':') >= 0) {
        var corte = n.textContent.indexOf(':');
        var etiqueta = n.textContent.slice(0, corte).trim();
        var resto = n.textContent.slice(corte + 1);

        var strong = document.createElement('strong');
        strong.textContent = etiqueta + ':';
        li.insertBefore(strong, n);
        n.textContent = resto;

        li.classList.add('is-spec');
        return;
      }

      /* Texto pelado y sin nodo que partir: se reescribe entero. Con algun
         elemento dentro no se toca, porque reescribirlo se llevaria por
         delante un enlace o un enfasis que alguien puso a proposito. */
      if (li.children.length) return;

      var strongPelado = document.createElement('strong');
      strongPelado.textContent = m[1].trim() + ':';
      li.textContent = '';
      li.appendChild(strongPelado);
      li.appendChild(document.createTextNode(' ' + m[2].trim()));
      li.classList.add('is-spec');
    });
  }

  /* ------------------------------------------------------------------
     3d. Ficha: los datos que deciden, arriba
     Las dimensiones y la capacidad de carga viven dentro de la descripcion,
     a tres mil pixeles del boton de comprar. Se suben hasta el precio.

     No se copia la ficha entera: tres filas y un enlace a lo demas. Un
     resumen que lo dice todo no es un resumen, es la misma pagina dos veces.
     ------------------------------------------------------------------ */

  /* Sin tildes, sin mayusculas y sin puntuacion: «Capacidad máxima de carga»
     y «capacidad maxima de carga:» son la misma etiqueta. */
  function kfNorm(t) {
    return (t || '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* Orden de interes, no orden de aparicion. Quien evalua un equipo pregunta
     primero si le entra por la puerta y cuanto aguanta; el material del
     bastidor viene despues. */
  var KF_PRIO = ['dimensi', 'medida', 'capacidad', 'carga', 'resistenc', 'peso',
                 'ancho', 'alto', 'largo', 'material', 'garant'];

  function kfScore(label) {
    var l = kfNorm(label);
    for (var i = 0; i < KF_PRIO.length; i++) {
      if (l.indexOf(KF_PRIO[i]) >= 0) return i;
    }
    return KF_PRIO.length;
  }

  function initKeyFacts() {
    var box = document.querySelector('[data-keyfacts]');
    var ficha = document.querySelector('.g-ficha');
    if (!box || !ficha) return;

    var have = [];
    [].forEach.call(box.querySelectorAll('dt'), function (dt) {
      have.push(kfNorm(dt.textContent));
    });

    var rows = [].slice.call(ficha.querySelectorAll('li.is-spec')).map(function (li) {
      var strong = li.querySelector('strong');
      var label = strong ? strong.textContent.replace(/\s*:\s*$/, '').trim() : '';
      /* El valor es todo lo que viene DESPUES del strong, no el textContent
         del li: eso traeria la etiqueta pegada al valor. */
      var value = '';
      var n = strong;
      while (n && (n = n.nextSibling)) value += n.textContent;
      value = value.replace(/^\s*[:\-]?\s*/, '').replace(/\s*\.\s*$/, '').trim();
      return { label: label, value: value, prio: kfScore(label) };
    }).filter(function (r) { return r.label && r.value; });

    /* `sort` es estable desde ES2019: dentro de la misma prioridad se
       conserva el orden en que estan escritas en la ficha. */
    rows.sort(function (a, b) { return a.prio - b.prio; });

    var added = 0;
    rows.forEach(function (r) {
      if (added >= 3) return;
      var key = kfNorm(r.label);
      if (have.indexOf(key) >= 0) return;
      have.push(key);

      var wrap = document.createElement('div');
      var dt = document.createElement('dt');
      var dd = document.createElement('dd');
      dt.textContent = r.label;
      dd.textContent = r.value;
      wrap.appendChild(dt);
      wrap.appendChild(dd);
      box.appendChild(wrap);
      added++;
    });

    if (box.querySelector('dt')) {
      var outer = box.closest('[data-keyfacts-box]');
      if (outer) outer.hidden = false;
    }
  }

  /* ------------------------------------------------------------------
     4b. Colección: los filtros
     El formulario no tenia quien lo enviara: su unico boton vivia dentro de
     un <noscript>, asi que con JavaScript activo marcar una casilla no hacia
     nada. Y el <select> de orden cuelga del mismo formulario, asi que cayo
     con el.

     Se resuelve con la Section Rendering API: se pide la seccion ya filtrada
     y se reemplaza el bloque, sin recargar la pagina ni perder el scroll.
     ------------------------------------------------------------------ */
  var fTimer = null;
  var fAbort = null;
  var fScrim = null;

  function fForm() { return document.getElementById('g-filter-form'); }

  /* La URL se construye SOBRE la actual y no desde cero: hay parametros que
     no son mios —preview_theme_id, utm_*— y borrarlos sacaria al usuario de
     la vista previa del borrador sin avisar. */
  /* Parametros que existen una sola vez por pagina. Los filtros se acumulan
     —tres marcas son tres `filter.p.vendor`— pero la busqueda es una, el
     orden es uno y el tipo es uno.

     Hizo falta al llevar los filtros a /search: ahi el termino viaja dos
     veces, en la URL y como campo oculto del formulario, que es lo que hace
     que filtrar funcione tambien sin JavaScript. Sin esta lista, cada
     filtrado sumaba otra copia de `q` y la URL crecia con cada clic. */
  var UNICOS = ['sort_by', 'q', 'type'];

  function fUrl(form) {
    var url = new URL(window.location.href);
    var next = new URLSearchParams();

    url.searchParams.forEach(function (v, k) {
      if (k.indexOf('filter.') === 0) return;
      if (k === 'page' || k === 'section_id') return;
      if (UNICOS.indexOf(k) >= 0) { next.set(k, v); return; }
      next.append(k, v);
    });

    new FormData(form).forEach(function (v, k) {
      if (v === '' || v == null) return;
      if (UNICOS.indexOf(k) >= 0) next.set(k, v); else next.append(k, v);
    });

    url.search = next.toString();
    return url;
  }

  /* El atajo puesto vuelve a la categoria de donde salio.

     La categoria viaja en `volver` porque Liquid no puede leer la cadena de
     consulta: la seccion deja el enlace apuntando al catalogo completo y
     aqui se le pone el destino fino. Si el parametro no viene, o no parece
     un handle, se queda el catalogo completo: un 404 es peor que volver a
     un sitio correcto pero generico.

     Se llama tambien despues de cada filtrado, porque el panel entero se
     reemplaza y el enlace nuevo vuelve a nacer generico. */
  function fBackLink(scope) {
    var link = (scope || document).querySelector('[data-back-base]');
    if (!link) return;
    var handle = new URLSearchParams(window.location.search).get('volver') || '';
    if (!/^[a-z0-9][a-z0-9-]{0,80}$/.test(handle)) return;
    link.href = link.dataset.backBase.replace(/\/$/, '') + '/' + handle;
  }

  function fRebind(fresh, mark) {
    fresh.removeAttribute('aria-busy');
    initQuantity(fresh);
    initViewToggle();
    initBulkSelect();
    fBackLink(fresh);

    var status = document.querySelector('[data-filter-status]');
    var count = fresh.querySelector('[data-filter-count]');
    if (status && count) status.textContent = count.textContent.trim();

    /* El foco vuelve al control equivalente. Sin esto, reemplazar el panel
       deja el foco en <body> y quien navega con teclado tiene que recorrer
       la pagina entera para volver a la casilla siguiente. */
    if (!mark) return;
    var cut = mark.indexOf('|');
    var name = mark.slice(0, cut);
    var value = mark.slice(cut + 1);
    var found = fresh.querySelectorAll('[name="' + name.replace(/"/g, '\\"') + '"]');
    for (var i = 0; i < found.length; i++) {
      if ((found[i].value || '') === value) { found[i].focus(); return; }
    }
    if (found[0]) found[0].focus();
  }

  function fApply(url, push) {
    var root = document.querySelector('[data-filter-root]');
    if (!root) return;

    var ask = new URL(url.href);
    ask.searchParams.set('section_id', root.dataset.section);

    var active = document.activeElement;
    var mark = active && active.name ? active.name + '|' + (active.value || '') : null;

    root.setAttribute('aria-busy', 'true');
    if (fAbort) fAbort.abort();
    fAbort = new AbortController();

    fetch(ask.href, { signal: fAbort.signal })
      .then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.text();
      })
      .then(function (html) {
        var fresh = new DOMParser()
          .parseFromString(html, 'text/html')
          .querySelector('[data-filter-root]');
        if (!fresh) throw new Error('sin raiz');
        root.replaceWith(fresh);
        if (push) window.history.pushState({ g: 'f' }, '', url.href);
        fRebind(fresh, mark);
      })
      .catch(function (e) {
        if (e.name === 'AbortError') return;
        /* Si la parte rapida falla, se hace lo lento: navegar. Un filtro que
           no responde es peor que uno que recarga la pagina. */
        window.location.href = url.href;
      });
  }

  function fDrawer(open) {
    var btn = document.querySelector('[data-filter-open]');
    document.body.classList.toggle('g-filters-open', open);
    if (btn) btn.setAttribute('aria-expanded', String(open));

    if (open) {
      var close = document.querySelector('[data-filter-close]');
      if (close) close.focus();
    } else if (btn) {
      btn.focus();
    }
  }

  function initFilters() {
    /* El velo se crea una vez y cuelga de <body>, no de la seccion: la
       seccion se reemplaza al filtrar y el velo desapareceria con el cajon
       todavia abierto. Elemento real y no ::after, porque un
       pseudoelemento se ve pero no recibe clics: el toque atravesaria el
       velo y caeria sobre un producto. */
    fBackLink();

    if (!fScrim) {
      fScrim = document.createElement('div');
      fScrim.className = 'g-scrim';
      fScrim.addEventListener('click', function () { fDrawer(false); });
      document.body.appendChild(fScrim);
    }

    document.addEventListener('change', function (e) {
      var form = fForm();
      var t = e.target;
      if (!form || !t.name || t.form !== form) return;
      if (t.type === 'number') return;
      fApply(fUrl(form), true);
    });

    /* El buscador del filtro no toca el servidor: esconde renglones de la
       lista que ya esta en pantalla. Filtrar «Yuwell» entre 44 marcas es
       una tarea del navegador, y hacerla contra Shopify seria pedir una
       pagina entera para tachar 43 lineas. */
    document.addEventListener('input', function (e) {
      var box = e.target.closest('[data-filter-search]');
      if (!box) return;

      var body = box.closest('.g-filter__body');
      var list = body.querySelector('[data-filter-list]');
      if (!list) return;

      /* Sin tildes y sin mayusculas: quien escribe «carecter» o «CARETEK»
         busca lo mismo que quien escribe «Caretek». */
      var norm = function (t) {
        return (t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
      };
      var needle = norm(box.value);
      var hits = 0;

      [].forEach.call(list.querySelectorAll('.g-check'), function (row) {
        var match = norm(row.textContent).indexOf(needle) >= 0;
        row.hidden = !match;
        if (match) hits++;
      });

      /* Buscando se muestran todas las coincidencias, no solo las ocho
         primeras: el «Ver mas» estorbaria justo cuando alguien ya dijo que
         busca. Al vaciar la caja se vuelve al estado que hubiera. */
      body.classList.toggle('is-expanded', needle !== '');
      if (list) list.classList.toggle('is-tall', needle !== '' || body.classList.contains('is-expanded'));

      var empty = body.querySelector('[data-filter-empty]');
      if (!empty) {
        empty = document.createElement('p');
        empty.className = 'g-filter__empty';
        empty.setAttribute('data-filter-empty', '');
        empty.textContent = box.dataset.empty || 'Sin coincidencias';
        list.after(empty);
      }
      empty.hidden = hits > 0;
    });

    /* El rango de precio espera: escribir «150000» dispararia seis
       consultas, una por digito. */
    document.addEventListener('input', function (e) {
      var form = fForm();
      var t = e.target;
      if (!form || t.form !== form || t.type !== 'number') return;
      clearTimeout(fTimer);
      fTimer = setTimeout(function () { fApply(fUrl(form), true); }, 500);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;

      /* Las pildoras de orden no tienen tuberia propia: mueven el <select>
         y disparan su `change`, que ya sabe pedir la seccion, escribir la
         URL y devolver el foco. Una funcion, un camino.

         Pulsar la activa vuelve al orden natural de la coleccion: sirve de
         interruptor y evita tener una pildora «quitar orden». */
      var pill = e.target.closest('[data-sort]');
      if (pill) {
        var sel = document.getElementById('sort-by');
        if (sel) {
          var was = pill.getAttribute('aria-pressed') === 'true';
          sel.value = was ? 'manual' : pill.dataset.sort;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      if (e.target.closest('[data-filter-open]')) { fDrawer(true); return; }
      if (e.target.closest('[data-filter-close]')) { fDrawer(false); return; }

      var more = e.target.closest('[data-filter-more]');
      if (more) {
        var body = more.closest('.g-filter__body');
        var shown = body.classList.toggle('is-expanded');
        more.setAttribute('aria-expanded', String(shown));
        more.textContent = shown ? more.dataset.less : more.dataset.more;

        /* Al desplegar, la lista pasa a tener techo y scroll propio. Sin
           esto el panel crecia a 1.987px con 44 marcas y tapaba los filtros
           de mas abajo. Al plegar se lo quita, para que ocho valores no
           queden dentro de una caja con barra de desplazamiento. */
        var list = body.querySelector('[data-filter-list]');
        if (list) list.classList.toggle('is-tall', shown);
        return;
      }

      /* Las fichas de filtro activo, «Limpiar» y la paginacion ya traen su
         URL desde Liquid. Se interceptan para que sigan el mismo camino
         rapido en vez de recargar. */
      /* «Limpiar» no usa el href de Liquid: collection.url es la coleccion
         pelada, y se lleva por delante el orden elegido y cualquier parametro
         ajeno, preview_theme_id entre ellos. Limpia filtros y nada mas. */
      if (e.target.closest('.g-filters__clear')) {
        e.preventDefault();
        var bare = new URL(window.location.href);
        var keep = new URLSearchParams();
        bare.searchParams.forEach(function (v, k) {
          if (k.indexOf('filter.') === 0 || k === 'page') return;
          keep.append(k, v);
        });
        bare.search = keep.toString();
        fApply(bare, true);
        return;
      }

      var link = e.target.closest('.g-chip, .g-pagination a');
      if (!link || !link.href) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      e.preventDefault();
      fApply(new URL(link.href, window.location.href), true);
      if (link.matches('.g-pagination a')) {
        var top = document.querySelector('.g-toolbar');
        if (top) window.scrollTo({ top: top.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('g-filters-open')) {
        fDrawer(false);
      }
    });

    /* Atras deshace el ultimo filtro en vez de salir de la coleccion. */
    window.addEventListener('popstate', function () {
      fApply(new URL(window.location.href), false);
    });
  }

  /* ------------------------------------------------------------------
     5. Colección: selección múltiple
     Agrega varios SKU al carrito en una sola llamada a /cart/add.js.
     ------------------------------------------------------------------ */
  function initBulkSelect() {
    var bar = document.querySelector('.g-bulkbar');
    if (!bar) return;

    var countEl = bar.querySelector('[data-bulk-count]');
    var selectAll = document.querySelector('[data-bulk-all]');

    function boxes() {
      return Array.prototype.slice.call(document.querySelectorAll('.g-row__check'));
    }

    function refresh() {
      var all = boxes();
      var checked = all.filter(function (b) { return b.checked; });

      if (countEl) countEl.textContent = checked.length;
      bar.hidden = checked.length === 0;

      all.forEach(function (b) {
        var row = b.closest('.g-row');
        if (row) row.classList.toggle('g-row--selected', b.checked);
      });

      if (selectAll) {
        selectAll.checked = checked.length === all.length && all.length > 0;
        selectAll.indeterminate = checked.length > 0 && checked.length < all.length;
      }
    }

    on(document, '.g-row__check', 'change', refresh);

    if (selectAll) {
      selectAll.addEventListener('change', function () {
        boxes().forEach(function (b) { b.checked = selectAll.checked; });
        refresh();
      });
    }

    var clear = bar.querySelector('[data-bulk-clear]');
    if (clear) {
      clear.addEventListener('click', function () {
        boxes().forEach(function (b) { b.checked = false; });
        refresh();
      });
    }

    var add = bar.querySelector('[data-bulk-add]');
    if (add) {
      add.addEventListener('click', function () {
        var items = boxes()
          .filter(function (b) { return b.checked; })
          .map(function (b) {
            var row = b.closest('.g-row');
            var qty = row.querySelector('input[type="number"]');
            return {
              id: parseInt(b.value, 10),
              quantity: parseInt(qty && qty.value, 10) || 1
            };
          })
          .filter(function (i) { return i.id; });

        if (!items.length) return;

        add.disabled = true;
        addToCart(items).then(function () {
          window.location.href = window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root + 'cart'
            : '/cart';
        }).catch(function () {
          add.disabled = false;
        });
      });
    }

    refresh();
  }

  /* ------------------------------------------------------------------
     5.b Agregar al pedido sin salir de la pagina

     El formulario `{% form 'product' %}` de Shopify hace POST a /cart/add
     y el servidor responde con una redireccion al carrito. Para una
     tienda donde se compra una cosa esta bien. Aqui no: el pedido tipico
     de una ortopedia son quince o veinte SKU distintos, y volver atras
     despues de cada uno significa perder la posicion en el listado, los
     filtros aplicados y la paginacion. Armar el pedido se vuelve tan
     incomodo que se abandona a medias.

     Se intercepta el envio y se manda a /cart/add.js, que agrega sin
     navegar. La confirmacion la da un aviso flotante con enlace al
     pedido, para que agregar no sea un acto a ciegas.

     Detalles que importan:

     - Se envia el FormData entero, no {id, quantity} armado a mano: asi
       viajan tambien las propiedades de linea y el plan de venta si el
       dia de manana se usan, sin tener que volver aqui.

     - `sections: 'header'` pide de paso la cabecera ya renderizada por
       el servidor. Con eso el contador y el total se actualizan con el
       formato de moneda de la tienda, en vez de formatearlos en el
       cliente y arriesgar que digan algo distinto del checkout.

     - Si no hay fetch no se intercepta nada: el formulario nativo sigue
       funcionando y el cliente llega al carrito. Peor experiencia, pero
       nunca un boton muerto.
     ------------------------------------------------------------------ */
  function pintarCabecera(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');

    /* Se reemplaza el contenido de dos piezas concretas y no la cabecera
       entera: dentro vive el cajon de categorias de movil con sus
       oyentes, y sustituir el nodo completo los tiraria a la basura junto
       con el estado de abierto o cerrado. */
    ['.g-header__action--cart', '[data-carro]'].forEach(function (sel) {
      var nueva = doc.querySelector(sel);
      var actual = document.querySelector(sel);
      if (nueva && actual) actual.innerHTML = nueva.innerHTML;
    });
  }

  function aviso(texto, esError, conEnlace) {
    var caja = document.querySelector('[data-aviso]');
    if (!caja) {
      caja = document.createElement('div');
      caja.className = 'g-aviso';
      caja.setAttribute('data-aviso', '');
      /* `status` y no `alert`: es una confirmacion, no una emergencia.
         Con `alert` el lector de pantalla interrumpe lo que este leyendo
         en cada producto agregado, que en un pedido de veinte SKU es
         insoportable. */
      caja.setAttribute('role', 'status');
      caja.setAttribute('aria-live', 'polite');
      document.body.appendChild(caja);
    }

    caja.classList.toggle('g-aviso--error', !!esError);
    caja.textContent = '';

    var t = document.createElement('span');
    t.textContent = texto;
    caja.appendChild(t);

    if (conEnlace) {
      var a = document.createElement('a');
      a.href = cartRoute('cart');
      a.textContent = 'Ver pedido';
      caja.appendChild(a);
    }

    caja.classList.add('is-visible');
    clearTimeout(aviso.reloj);
    aviso.reloj = setTimeout(function () {
      caja.classList.remove('is-visible');
    }, esError ? 6000 : 4000);
  }

  /* ------------------------------------------------------------------
     5.c Cajon del pedido

     Se abre al agregar y deja ajustar cantidades sin salir del listado.

     El contenido SIEMPRE lo renderiza el servidor: se pide con
     `sections: 'header'` en la misma llamada que agrega o cambia la
     cantidad. Nada de recalcular precios ni totales en el cliente. Con
     precios por tramo de volumen, un total calculado aqui acabaria
     discrepando del checkout, y quien se entera es el cliente.
     ------------------------------------------------------------------ */
  var focoPrevio = null;

  function cajon() { return document.querySelector('[data-carro]'); }

  function abrirCajon() {
    var c = cajon();
    if (!c) return;
    focoPrevio = document.activeElement;
    var telon = document.querySelector('[data-carro-telon]');
    if (telon) telon.hidden = false;
    c.hidden = false;
    /* Un fotograma de margen: el navegador necesita ver el elemento
       visible antes de poder animar la transicion. Sin esto aparece de
       golpe, sin deslizarse. */
    requestAnimationFrame(function () {
      c.classList.add('is-open');
      if (telon) telon.classList.add('is-open');
      var cerrar = c.querySelector('[data-carro-cerrar]');
      if (cerrar) cerrar.focus();
    });
    document.documentElement.classList.add('g-sin-scroll');
  }

  function cerrarCajon() {
    var c = cajon();
    if (!c || c.hidden) return;
    var telon = document.querySelector('[data-carro-telon]');
    c.classList.remove('is-open');
    if (telon) telon.classList.remove('is-open');
    document.documentElement.classList.remove('g-sin-scroll');
    setTimeout(function () {
      c.hidden = true;
      if (telon) telon.hidden = true;
    }, 260);
    /* Devolver el foco a donde estaba. Si no, quien navega con teclado
       reaparece al principio de la pagina y pierde su sitio. */
    if (focoPrevio && focoPrevio.focus) focoPrevio.focus();
    focoPrevio = null;
  }

  function cambiarLinea(linea, cantidad, boton) {
    if (boton) boton.disabled = true;
    return fetch(cartRoute('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        line: linea,
        quantity: cantidad,
        sections: 'header',
        sections_url: window.location.pathname
      })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'No se pudo actualizar el pedido');
          return data;
        });
      })
      .then(function (data) {
        pintarCabecera(data.sections && data.sections.header);
      })
      .catch(function (err) {
        aviso(err.message, true, false);
        if (boton) boton.disabled = false;
      });
  }

  function initCajonPedido() {
    if (initCajonPedido.listo) return;
    initCajonPedido.listo = true;

    /* Todo delegado en document: el cajon se repinta entero en cada
       cambio de cantidad, asi que un oyente atado a sus botones moriria
       en el primer clic. */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      if (t.closest('[data-carro-cerrar]') || t.closest('[data-carro-telon]')) {
        cerrarCajon();
        return;
      }

      /* El icono del carro abre el cajon en vez de navegar. Sigue siendo
         un enlace a /carrito, asi que sin JS lleva a la pagina de siempre
         y no se rompe nada. */
      var iconoCarro = t.closest('.g-header__action--cart');
      if (iconoCarro && cajon()) {
        e.preventDefault();
        abrirCajon();
        return;
      }

      var paso = t.closest('[data-carro-cantidad]');
      if (paso) {
        var item = paso.closest('[data-carro-linea]');
        if (!item) return;
        cambiarLinea(
          parseInt(item.getAttribute('data-carro-linea'), 10),
          parseInt(paso.getAttribute('data-carro-cantidad'), 10),
          paso
        );
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { cerrarCajon(); return; }

      /* Foco atrapado mientras el cajon esta abierto. Es un dialogo
         modal: si el tabulador se escapa al listado de atras, quien
         navega con teclado queda moviendose por una pagina que no ve. */
      if (e.key !== 'Tab') return;
      var c = cajon();
      if (!c || c.hidden) return;
      var foco = c.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
      if (!foco.length) return;
      var primero = foco[0];
      var ultimo = foco[foco.length - 1];
      if (e.shiftKey && document.activeElement === primero) {
        e.preventDefault();
        ultimo.focus();
      } else if (!e.shiftKey && document.activeElement === ultimo) {
        e.preventDefault();
        primero.focus();
      }
    });
  }

  function initAgregarSinSalir() {
    if (initAgregarSinSalir.listo) return;
    initAgregarSinSalir.listo = true;

    /* Delegado en document y no por formulario: al filtrar una coleccion
       se reemplaza la grilla entera, y unos oyentes atados a cada tarjeta
       se irian con el nodo viejo sin que nadie lo note. */
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest
        ? e.target.closest('form[action*="/cart/add"]')
        : null;
      if (!form || !window.fetch || !window.FormData) return;

      e.preventDefault();

      var boton = form.querySelector('button[type="submit"]');
      var etiqueta = boton ? boton.innerHTML : '';
      var datos = new FormData(form);
      datos.append('sections', 'header');
      datos.append('sections_url', window.location.pathname);

      if (boton) boton.disabled = true;

      function restaurar() {
        if (!boton) return;
        boton.disabled = false;
        boton.innerHTML = etiqueta;
      }

      fetch(cartRoute('cart/add.js'), {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: datos
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) {
              /* Shopify explica aqui por que no se pudo, y para los casos
                 que un cliente si puede provocar —sin stock, cantidad
                 sobre el maximo— el texto viene en el idioma de la
                 tienda y es mas util que un "error" generico nuestro.

                 El 404 es la excepcion: significa que la variante ya no
                 existe, llega como «Cannot find variant» en ingles y no
                 es culpa de quien compra. Ese se reescribe. */
              if (res.status === 404) {
                throw new Error('Este producto ya no esta disponible. Actualiza la pagina.');
              }
              throw new Error(data.description || data.message || 'No se pudo agregar al pedido');
            }
            return data;
          });
        })
        .then(function (data) {
          pintarCabecera(data.sections && data.sections.header);

          var item = data.items ? data.items[0] : data;
          var nombre = (item && (item.product_title || item.title)) || 'Producto';
          /* La cantidad que se acaba de agregar, no `item.quantity`: eso
             ultimo es el total de la linea DESPUES de sumar, asi que a
             quien ya llevaba tres y agrega tres le decia «x 6 agregado».
             Se toma del propio formulario, que es lo que el comprador
             acaba de pedir. */
          var cuantos = parseInt(datos.get('quantity'), 10) || 1;

          /* Con cajon, el cajon es la confirmacion: muestra lo recien
             agregado y todo lo demas que ya lleva. El aviso flotante
             queda de respaldo por si el cajon no existe —una plantilla
             sin cabecera, por ejemplo— para que agregar nunca sea un acto
             a ciegas. */
          if (cajon()) {
            abrirCajon();
          } else {
            aviso(nombre + ' × ' + cuantos + ' agregado a tu pedido', false, true);
          }

          if (boton) {
            boton.innerHTML = 'Agregado';
            setTimeout(restaurar, 1600);
          }
        })
        .catch(function (err) {
          aviso(err.message, true, false);
          restaurar();
        });
    });
  }

  /* ------------------------------------------------------------------
     6. Carrito
     Shopify recalcula los totales en el servidor, así que cambiar una
     cantidad implica llamar a /cart/change.js y volver a pintar. No se
     calculan totales en el cliente: quedarían desalineados con el
     checkout, que es la única fuente de verdad.
     ------------------------------------------------------------------ */
  function cartRoute(path) {
    var root = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';
    return root + path;
  }

  function addToCart(items) {
    return fetch(cartRoute('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error('No se pudo agregar al pedido');
      return res.json();
    });
  }

  function initCart() {
    var form = document.querySelector('[data-cart-form]');
    if (!form) return;

    form.addEventListener('change', function (e) {
      var input = e.target.closest('input[type="number"][data-line]');
      if (!input) return;

      updateLine(input.dataset.line, parseInt(input.value, 10) || 0);
    });

    on(form, '[data-line-remove]', 'click', function (e) {
      e.preventDefault();
      updateLine(e.currentTarget.dataset.lineRemove, 0);
    });

    /* La orden de compra y las instrucciones viajaban SOLO al pulsar
       «Finalizar pedido». Ahora se guardan al salir del campo y, con
       retraso, mientras se escribe. */
    var fieldTimer = null;

    function fieldsOf(form) {
      return {
        po: form.querySelector('[name="attributes[Orden de compra]"]'),
        note: form.querySelector('[name="note"]')
      };
    }

    function saveFields() {
      var f = fieldsOf(form);
      if (!f.po && !f.note) return Promise.resolve();

      var body = { attributes: {} };
      if (f.po) body.attributes['Orden de compra'] = f.po.value;
      if (f.note) body.note = f.note.value;

      return fetch(cartRoute('cart/update.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function () { flagSaved(); })
        .catch(function () { /* se reintenta al salir del campo */ });
    }

    /* Un aviso discreto y no un cartel: confirma sin pedir que lo lean. */
    function flagSaved() {
      var tag = form.querySelector('[data-cart-saved]');
      if (!tag) return;
      tag.hidden = false;
      clearTimeout(tag._t);
      tag._t = setTimeout(function () { tag.hidden = true; }, 2200);
    }

    form.addEventListener('input', function (e) {
      if (!e.target.matches('[name="attributes[Orden de compra]"], [name="note"]')) return;
      clearTimeout(fieldTimer);
      fieldTimer = setTimeout(saveFields, 700);
    });

    form.addEventListener('focusout', function (e) {
      if (!e.target.matches('[name="attributes[Orden de compra]"], [name="note"]')) return;
      clearTimeout(fieldTimer);
      saveFields();
    });

    function updateLine(line, quantity) {
      form.setAttribute('aria-busy', 'true');
      clearTimeout(fieldTimer);

      /* Primero se guarda lo escrito y despues se cambia la cantidad: este
         camino termina en una recarga, y sin este orden el numero de orden
         a medio escribir se perderia en ella. */
      saveFields()
        .then(function () {
          return fetch(cartRoute('cart/change.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ line: parseInt(line, 10), quantity: quantity })
          });
        })
        .then(function (res) { return res.json(); })
        .then(function () { window.location.reload(); })
        .catch(function () { form.removeAttribute('aria-busy'); });
    }
  }

  /* ------------------------------------------------------------------
     7. Contador de la oferta del mes
     ------------------------------------------------------------------ */
  function initCountdown() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var target = new Date(el.dataset.countdown).getTime();
      if (isNaN(target)) return;

      var slots = {
        d: el.querySelector('[data-cd="d"]'),
        h: el.querySelector('[data-cd="h"]'),
        m: el.querySelector('[data-cd="m"]'),
        s: el.querySelector('[data-cd="s"]')
      };

      function pad(n) { return String(Math.max(0, n)).padStart(2, '0'); }

      var timer = setInterval(tick, 1000);
      tick();

      function tick() {
        var left = target - Date.now();

        if (left <= 0) {
          el.hidden = true;
          clearInterval(timer);
          return;
        }

        var total = Math.floor(left / 1000);
        if (slots.d) slots.d.textContent = pad(Math.floor(total / 86400));
        if (slots.h) slots.h.textContent = pad(Math.floor(total / 3600) % 24);
        if (slots.m) slots.m.textContent = pad(Math.floor(total / 60) % 60);
        if (slots.s) slots.s.textContent = pad(total % 60);
      }
    });
  }

  /* ------------------------------------------------------------------
     8. Carga rápida por SKU
     Shopify no tiene endpoint público de búsqueda por SKU, así que se usa
     /search/suggest.json y se filtra por coincidencia exacta del SKU de la
     variante. Es la única vía sin app y sin exponer el catálogo entero.
     ------------------------------------------------------------------ */
  function initQuickOrder() {
    var root = document.querySelector('[data-quick-order]');
    if (!root) return;

    var form = root.querySelector('[data-quick-order-form]');
    if (!form) return;

    var tbody = root.querySelector('[data-quick-order-rows]');
    var summary = root.querySelector('[data-qo-summary]');
    var submit = root.querySelector('[data-qo-submit]');
    var addRow = root.querySelector('[data-qo-add-row]');
    var cache = {};

    function lookup(sku) {
      var key = sku.toUpperCase();
      if (cache[key]) return Promise.resolve(cache[key]);

      var url = cartRoute('search/suggest.json') +
                '?q=' + encodeURIComponent(sku) +
                '&resources[type]=product&resources[limit]=10';

      return fetch(url)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var products = (data.resources.results.products || []);
          var match = null;

          products.forEach(function (p) {
            (p.variants || []).forEach(function (v) {
              if (v.sku && v.sku.toUpperCase() === key) match = v;
            });
          });

          cache[key] = match;
          return match;
        })
        .catch(function () { return null; });
    }

    function refreshRow(row) {
      var skuInput = row.querySelector('[data-qo-sku]');
      var qtyInput = row.querySelector('[data-qo-qty]');
      var nameCell = row.querySelector('[data-qo-name]');
      var totalCell = row.querySelector('[data-qo-total]');

      var sku = (skuInput.value || '').trim();

      if (!sku) {
        row.removeAttribute('data-variant');
        nameCell.textContent = '—';
        totalCell.textContent = '—';
        refreshTotals();
        return;
      }

      lookup(sku).then(function (variant) {
        if (!variant) {
          row.removeAttribute('data-variant');
          nameCell.textContent = root.dataset.notFound || 'SKU no encontrado';
          nameCell.classList.add('g-qo-error');
          totalCell.textContent = '—';
          refreshTotals();
          return;
        }

        nameCell.classList.remove('g-qo-error');
        row.dataset.variant = variant.id;
        row.dataset.price = variant.price;
        nameCell.textContent = variant.title || variant.name;

        var qty = parseInt(qtyInput.value, 10) || 0;
        totalCell.textContent = qty > 0 ? money(variant.price * qty) : '—';
        refreshTotals();
      });
    }

    function refreshTotals() {
      var total = 0;
      var count = 0;

      tbody.querySelectorAll('[data-qo-row]').forEach(function (row) {
        var qty = parseInt(row.querySelector('[data-qo-qty]').value, 10) || 0;
        var price = parseInt(row.dataset.price, 10) || 0;
        if (row.dataset.variant && qty > 0) {
          total += price * qty;
          count += 1;
        }
      });

      if (summary) {
        summary.textContent = count > 0 ? money(total) : '';
      }
      if (submit) {
        submit.disabled = count === 0;
      }
    }

    // Debounce, para no disparar una búsqueda por cada tecla
    var timers = new WeakMap();

    tbody.addEventListener('input', function (e) {
      var row = e.target.closest('[data-qo-row]');
      if (!row) return;

      if (e.target.matches('[data-qo-qty]')) {
        refreshRow(row);
        return;
      }

      if (e.target.matches('[data-qo-sku]')) {
        clearTimeout(timers.get(row));
        timers.set(row, setTimeout(function () { refreshRow(row); }, 350));
      }
    });

    if (addRow) {
      addRow.addEventListener('click', function () {
        var last = tbody.querySelector('[data-qo-row]:last-child');
        var copy = last.cloneNode(true);

        copy.removeAttribute('data-variant');
        copy.removeAttribute('data-price');
        copy.querySelectorAll('input').forEach(function (i) {
          i.value = '';
          i.removeAttribute('id');
        });
        copy.querySelector('[data-qo-name]').textContent = '—';
        copy.querySelector('[data-qo-total]').textContent = '—';

        tbody.appendChild(copy);
      });
    }

    // Al enviar, se arma el payload con las filas resueltas
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var items = [];
      tbody.querySelectorAll('[data-qo-row]').forEach(function (row) {
        var qty = parseInt(row.querySelector('[data-qo-qty]').value, 10) || 0;
        if (row.dataset.variant && qty > 0) {
          items.push({ id: parseInt(row.dataset.variant, 10), quantity: qty });
        }
      });

      if (!items.length) return;

      submit.disabled = true;
      addToCart(items)
        .then(function () { window.location.href = cartRoute('cart'); })
        .catch(function () { submit.disabled = false; });
    });

    refreshTotals();
  }

  /* ------------------------------------------------------------------
     9. Detalle expandible de pedidos
     ------------------------------------------------------------------ */
  function initOrderDetails() {
    on(document, '.g-expand', 'click', function (e) {
      var btn = e.currentTarget;
      var row = document.getElementById(btn.getAttribute('aria-controls'));
      if (!row) return;

      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      row.hidden = open;
    });

    /* El panel enlaza cada pedido con #pedido-<id>. Sin esto, "Ver" deja al
       cliente frente a la tabla completa y con el suyo todavia cerrado: le
       pedimos que vuelva a buscar lo que acaba de pedir. */
    var target = location.hash && document.querySelector(location.hash);
    if (target) {
      var toggle = target.querySelector('.g-expand');
      if (toggle && toggle.getAttribute('aria-expanded') !== 'true') {
        toggle.click();
      }
      target.scrollIntoView({ block: 'center' });
    }
  }


  /* ------------------------------------------------------------------
     10. Te podria estar faltando

     Liquid deja escrito el historial de lineas —variante, fecha del pedido,
     cantidad— y el agrupamiento se hace aca. El motivo es de rendimiento:
     Liquid no tiene diccionarios, asi que agrupar por producto obliga a
     bucles anidados con comparaciones de cadenas, en cada carga y sin poder
     cachear nada. Un Map en JS resuelve lo mismo en una pasada.

     La cadencia es el promedio entre compras, no el intervalo de las dos
     ultimas: una compra doble en la misma semana no debe convertir una
     reposicion mensual en semanal.
     ------------------------------------------------------------------ */
  var DAY = 86400;

  function suggestionsFrom(history, now) {
    var byVariant = new Map();

    history.forEach(function (line) {
      var e = byVariant.get(line.v);
      if (!e) {
        e = { v: line.v, sku: line.s, name: line.n, days: [], qty: [] };
        byVariant.set(line.v, e);
      }
      /* Dos lineas del mismo producto en un pedido son una sola compra. */
      if (e.days.indexOf(line.t) === -1) e.days.push(line.t);
      e.qty.push(line.q);
      /* El nombre mas reciente manda: los titulos se editan. */
      if (line.t >= Math.max.apply(null, e.days)) e.name = line.n;
    });

    var out = [];
    byVariant.forEach(function (e) {
      /* Con una sola compra no hay ritmo que medir. Adivinarlo a partir de
         un punto seria inventar el dato que justifica todo el panel. */
      if (e.days.length < 2) return;

      e.days.sort(function (a, b) { return b - a; });
      var span = e.days[0] - e.days[e.days.length - 1];
      var cadence = Math.round(span / (e.days.length - 1) / DAY);
      if (cadence < 1) return;

      var since = Math.round((now - e.days[0]) / DAY);

      /* La cantidad habitual es la que mas se repite, no el promedio: un
         promedio de 12 y 36 da 24, que puede ser una cifra que el cliente
         no ha pedido nunca. */
      var freq = {};
      var usual = e.qty[0];
      var best = 0;
      e.qty.forEach(function (q) {
        freq[q] = (freq[q] || 0) + 1;
        if (freq[q] > best) { best = freq[q]; usual = q; }
      });

      out.push({
        v: e.v, sku: e.sku, name: e.name,
        cadence: cadence, since: since, usual: usual,
        late: since - cadence
      });
    });

    /* Lo mas atrasado primero; entre los que no lo estan, el mas proximo. */
    out.sort(function (a, b) { return b.late - a.late; });
    return out;
  }

  /* --- Plantillas de reposicion -----------------------------------------

     Lo que se guarda es minimo a proposito: un objeto { idPedido: nombre }.
     Los productos, las cantidades y las fechas ya los imprime Liquid desde
     el pedido, y duplicarlos en el navegador solo crearia una copia capaz
     de quedar desfasada del pedido real.

     Todo acceso a localStorage va en try/catch: en ventana privada, con el
     almacenamiento bloqueado o lleno, el acceso lanza. La pagina tiene que
     seguir funcionando sin los nombres, porque los pedidos —que son lo que
     importa— vienen del servidor igual. */
  var TPL_KEY = 'glomax:plantillas';

  function tplRead() {
    try { return JSON.parse(localStorage.getItem(TPL_KEY)) || {}; }
    catch (err) { return {}; }
  }

  function tplWrite(map) {
    try { localStorage.setItem(TPL_KEY, JSON.stringify(map)); return true; }
    catch (err) { return false; }
  }

  function tplHas(map, id) {
    return Object.prototype.hasOwnProperty.call(map, id);
  }

  /* Una entrada guardada era solo el nombre; ahora tambien lleva frecuencia.
     Se lee de las dos formas —cadena o ficha— porque hay navegadores con lo
     anterior ya escrito, y se vuelve a escribir como cadena cuando no hay
     frecuencia: lo mas simple que represente el estado. */
  function tplGet(saved, id) {
    var v = saved[id];
    if (typeof v === 'string') return { n: v, f: 0 };
    return { n: (v && v.n) || '', f: (v && v.f) || 0 };
  }

  function tplSet(saved, id, e) {
    saved[id] = e.f > 0 ? { n: e.n, f: e.f } : (e.n || '');
  }

  /* Los ocultos van en su propia clave y no como una marca dentro de la
     anterior. Son dos decisiones distintas del comprador —esta la quiero
     arriba, esta no la quiero ver— y mezclarlas obligaria a que borrar un
     nombre tuviera que acordarse de no borrar el ocultamiento. */
  var TPL_HIDE_KEY = 'glomax:plantillas-ocultas';

  function tplHiddenRead() {
    try { return JSON.parse(localStorage.getItem(TPL_HIDE_KEY)) || {}; }
    catch (err) { return {}; }
  }

  function tplHiddenWrite(map) {
    try { localStorage.setItem(TPL_HIDE_KEY, JSON.stringify(map)); }
    catch (err) { /* sin almacenamiento la lista simplemente no se filtra */ }
  }

  function initTemplates(scope) {
    (scope || document).querySelectorAll('[data-tpls]').forEach(function (list) {
      if (list.dataset.ready) return;
      list.dataset.ready = '1';

      var saved = tplRead();
      var hid = tplHiddenRead();
      var cards = Array.prototype.slice.call(list.querySelectorAll('[data-tpl]'));
      var text = list.dataset.tplText ? JSON.parse(list.dataset.tplText) : {};

      /* La barra de ocultos vive fuera de la reja: dentro seria una celda mas
         y se alinearia con las tarjetas, que es justo lo que no es. */
      var bar = document.querySelector('[data-tpl-hidden-bar]');
      var barCount = bar && bar.querySelector('[data-tpl-hidden-count]');
      var barBtn = bar && bar.querySelector('[data-tpl-reveal]');
      var revealed = false;
      var painters = [];

      function refresh() {
        var n = 0;
        painters.forEach(function (p) { if (p()) n += 1; });
        if (!bar) return;
        bar.hidden = n === 0;
        if (n === 0) { revealed = false; }
        if (barCount) {
          barCount.textContent = n === 1
            ? (text.hiddenOne || '')
            : (text.hiddenMany || '').replace('{n}', n);
        }
        if (barBtn) {
          barBtn.textContent = revealed ? (text.collapse || '') : (text.reveal || '');
          barBtn.setAttribute('aria-expanded', revealed ? 'true' : 'false');
        }
      }

      if (barBtn) {
        barBtn.addEventListener('click', function () {
          revealed = !revealed;
          refresh();
        });
      }

      cards.forEach(function (card) {
        var id = card.dataset.tpl;
        var name = card.querySelector('[data-tpl-name]');
        var pin = card.querySelector('[data-tpl-pin]');
        var slot = card.querySelector('.g-template__total');
        var base = name ? name.textContent.trim() : '';
        if (!pin || !name || !slot) return;

        function mk(cls, label) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'g-tpl-rename' + (cls ? ' ' + cls : '');
          b.textContent = label || '';
          return b;
        }

        var sched = card.querySelector('[data-tpl-sched]');
        var dueEl = card.querySelector('[data-tpl-due]');
        var freqEl = card.querySelector('[data-tpl-freq]');
        var tell = card.querySelector('[data-tpl-tell]');

        /* El mensaje lo arma el navegador porque la frecuencia solo existe
           aca. Es el unico puente por el que Glomax puede enterarse de ella;
           sin el, el recordatorio por correo no tendria de donde salir. */
        function waHref(e) {
          var order = card.dataset.tplOrder || '';
          var label = e.n ? (e.n + ' (' + order + ')') : order;
          var msg = (text.waText || '')
            .replace('{name}', label)
            .replace('{freq}', e.f)
            .replace('{list}', card.dataset.tplList || '');
          return 'https://wa.me/' + text.wa + '?text=' + encodeURIComponent(msg);
        }

        var rename = mk('', text.rename || 'Renombrar');
        var drop = mk('g-tpl-drop', text.remove || 'Quitar');
        var hide = mk('g-tpl-drop', text.hide || 'No mostrar acá');
        var unhide = mk('', text.unhide || 'Volver a mostrar');

        /* Devuelve si esta tarjeta cuenta como oculta, para que la barra sepa
           cuantas hay sin volver a recorrer el DOM. */
        function paint() {
          var on = tplHas(saved, id);
          /* Guardada manda sobre oculta: nadie destaca algo para esconderlo.
             Por eso fijar limpia el ocultamiento en vez de competir con el. */
          var out = !on && tplHas(hid, id);

          card.classList.toggle('is-pinned', on);
          card.classList.toggle('is-out', out);
          card.hidden = out && !revealed;

          pin.setAttribute('aria-pressed', on ? 'true' : 'false');
          pin.title = on ? (text.unpin || '') : (text.pin || '');
          var e = tplGet(saved, id);
          name.textContent = (on && e.n) ? e.n : base;

          if (sched) {
            sched.hidden = !on;
            if (on) {
              if (freqEl) freqEl.value = String(e.f);
              /* Dias corridos desde el pedido, redondeados hacia abajo: decir
                 "hace 34 dias" el dia 34 y medio es correcto; decir 35 no. */
              /* La fecha se relee en cada pintada, junto al reloj contra el
                 que se compara: los dos extremos de la resta en el mismo
                 sitio se leen mejor que uno cacheado arriba. */
              var at = parseInt(card.dataset.tplAt, 10) || 0;
              var days = at ? Math.floor((Date.now() / 1000 - at) / DAY) : 0;
              var due = e.f > 0 && days >= e.f;
              if (dueEl) {
                dueEl.hidden = !due;
                if (due) dueEl.textContent = (text.due || '').replace('{n}', days);
              }
              if (tell) {
                tell.hidden = !(e.f > 0 && text.wa);
                if (!tell.hidden) tell.href = waHref(e);
              }
            }
          }

          slot.textContent = '';
          if (on) { slot.appendChild(rename); slot.appendChild(drop); }
          else if (out) { slot.appendChild(unhide); }
          else { slot.appendChild(hide); }

          return out;
        }
        painters.push(paint);

        pin.disabled = false;
        pin.addEventListener('click', function () {
          if (tplHas(saved, id)) { delete saved[id]; }
          else { saved[id] = ''; delete hid[id]; tplHiddenWrite(hid); }
          tplWrite(saved);
          refresh();
        });

        if (freqEl) {
          freqEl.addEventListener('change', function () {
            var e = tplGet(saved, id);
            e.f = parseInt(freqEl.value, 10) || 0;
            tplSet(saved, id, e);
            tplWrite(saved);
            refresh();
          });
        }

        drop.addEventListener('click', function () {
          delete saved[id];
          tplWrite(saved);
          refresh();
          /* El foco estaba en un boton que acaba de desaparecer. Se pasa a la
             estrella, que es lo que queda en su lugar y permite deshacerlo. */
          pin.focus();
        });

        hide.addEventListener('click', function () {
          hid[id] = true;
          tplHiddenWrite(hid);
          refresh();
          /* La tarjeta se va de la pantalla; el foco no puede irse con ella.
             Pasa al control que la recupera, que ademas acaba de aparecer. */
          if (barBtn && !bar.hidden) barBtn.focus();
        });

        unhide.addEventListener('click', function () {
          delete hid[id];
          tplHiddenWrite(hid);
          refresh();
          pin.focus();
        });

        rename.addEventListener('click', function () {
          /* El campo reemplaza al titulo en su sitio, con su mismo tamano:
             renombrar es editar lo que ya se esta leyendo, no abrir un
             formulario aparte. */
          var input = document.createElement('input');
          input.type = 'text';
          input.className = 'g-tpl-name-input';
          input.value = name.textContent.trim();
          input.setAttribute('aria-label', text.nameLabel || '');
          name.replaceWith(input);
          input.focus();
          input.select();

          function close(keep) {
            var v = input.value.trim();
            if (keep) {
              /* Se lee la ficha entera antes de escribirla: guardar solo el
                 nombre borraria la frecuencia que ya estaba puesta. */
              var e = tplGet(saved, id);
              e.n = (v && v !== base) ? v : '';
              tplSet(saved, id, e);
              tplWrite(saved);
            }
            input.replaceWith(name);
            refresh();
          }
          input.addEventListener('blur', function () { close(true); });
          input.addEventListener('keydown', function (ev) {
            if (ev.key === 'Enter') { ev.preventDefault(); close(true); }
            if (ev.key === 'Escape') { close(false); }
          });
        });
      });

      refresh();

      /* Las guardadas suben. Se recorren al reves para que conserven entre
         ellas el orden en que venian, que es el de los pedidos. */
      cards.slice().reverse().forEach(function (card) {
        if (tplHas(saved, card.dataset.tpl)) list.insertBefore(card, list.firstChild);
      });
    });
  }

  function initTemplateSave(scope) {
    (scope || document).querySelectorAll('[data-tpl-save]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';

      var id = btn.dataset.tplSave;
      var label = btn.querySelector('[data-tpl-label]');
      var done = btn.dataset.tplDone || '';
      var see = btn.dataset.tplSee || '';
      var url = btn.dataset.tplUrl || '';
      var saved = tplRead();

      function mark() {
        btn.disabled = true;
        btn.classList.add('is-done');
        if (label && done) label.textContent = done;
        /* Al final de la fila de acciones y no pegado al boton: al lado ya
           puede haber un "Pagar este pedido", y colarse entre los dos
           separaria el par. La guarda contra duplicados mira la clase y no
           el hermano siguiente, que es justo lo que fallaba. */
        if (url && see && !btn.parentNode.querySelector('.g-tpl-see')) {
          var a = document.createElement('a');
          a.className = 'g-tpl-rename g-tpl-see';
          a.href = url;
          a.textContent = see;
          btn.parentNode.appendChild(a);
        }
      }

      if (tplHas(saved, id)) { mark(); return; }

      btn.disabled = false;
      btn.addEventListener('click', function () {
        saved = tplRead();
        saved[id] = '';
        if (tplWrite(saved)) mark();
      });
    });
  }

  function initSuggestions(scope) {
    (scope || document).querySelectorAll('[data-sugg]').forEach(function (panel) {
      if (panel.dataset.ready) return;
      panel.dataset.ready = '1';

      var history, text;
      try {
        history = JSON.parse(panel.querySelector('[data-sugg-history]').textContent);
        text = JSON.parse(panel.querySelector('[data-sugg-text]').textContent);
      } catch (err) { return; }

      var max = parseInt(panel.dataset.suggMax, 10) || 5;
      var items = suggestionsFrom(history, Math.floor(Date.now() / 1000)).slice(0, max);
      if (!items.length) return;

      var rows = panel.querySelector('[data-sugg-rows]');
      var overdue = [];

      items.forEach(function (it) {
        var isLate = it.late > 0;
        if (isLate) overdue.push(it);

        var tr = document.createElement('tr');

        var td1 = document.createElement('td');
        var strong = document.createElement('strong');
        strong.textContent = it.name;
        var meta = document.createElement('small');
        meta.className = 'g-sugg__meta';
        var bits = [];
        if (it.sku) bits.push(text.sku.replace('%v', it.sku));
        bits.push(text.usual.replace('%n', it.usual));
        meta.textContent = bits.join(' · ');
        td1.appendChild(strong);
        td1.appendChild(meta);

        var td2 = document.createElement('td');
        td2.className = 'g-table__num';
        td2.textContent = text.every.replace('%n', it.cadence);

        var td3 = document.createElement('td');
        td3.appendChild(document.createTextNode(text.since.replace('%n', it.since)));
        if (isLate) {
          var lateEl = document.createElement('small');
          lateEl.className = 'g-sugg__late';
          lateEl.textContent = text.late.replace('%n', it.late);
          td3.appendChild(lateEl);
        }

        var td4 = document.createElement('td');
        td4.className = 'g-table__right';
        td4.appendChild(addForm(panel, [it], text.add.replace('%n', it.usual), isLate));

        tr.appendChild(td1); tr.appendChild(td2); tr.appendChild(td3); tr.appendChild(td4);
        rows.appendChild(tr);
      });

      /* Solo con mas de uno: con uno solo repetiria el boton de su fila. */
      if (overdue.length > 1) {
        panel.querySelector('[data-sugg-all]')
             .appendChild(addForm(panel, overdue, text.addAll, true));
      }

      panel.hidden = false;
    });
  }

  function addForm(panel, items, label, primary) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = panel.dataset.suggCart;
    items.forEach(function (it) {
      form.appendChild(hidden('items[][id]', it.v));
      form.appendChild(hidden('items[][quantity]', it.usual));
    });
    var btn = document.createElement('button');
    btn.type = 'submit';
    btn.className = 'g-btn g-btn--sm ' + (primary ? 'g-btn--primary' : 'g-btn--ghost');
    btn.textContent = label;
    form.appendChild(btn);
    return form;
  }

  function hidden(name, value) {
    var i = document.createElement('input');
    i.type = 'hidden';
    i.name = name;
    i.value = value;
    return i;
  }


  /* ------------------------------------------------------------------
     11. Carrusel de familias

     El desplazamiento lo hace el navegador: el track es un scroller nativo
     y ya responde al dedo, a la rueda y al teclado sin una linea de JS. Lo
     que se agrega aca es solo la comodidad del puntero, asi que las flechas
     nacen ocultas y solo aparecen si este codigo corre y si hay algo fuera
     de la vista.
     ------------------------------------------------------------------ */
  function initRails(scope) {
    (scope || document).querySelectorAll('[data-rail]').forEach(function (rail) {
      if (rail.dataset.ready) return;
      rail.dataset.ready = '1';

      var track = rail.querySelector('[data-rail-track]');
      var nav = rail.querySelector('[data-rail-nav]');
      if (!track || !nav) return;

      var prev = nav.querySelector('[data-rail-prev]');
      var next = nav.querySelector('[data-rail-next]');

      function overflows() {
        return track.scrollWidth - track.clientWidth > 4;
      }

      function sync() {
        if (!overflows()) { nav.hidden = true; return; }
        nav.hidden = false;
        var max = track.scrollWidth - track.clientWidth;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max - 2;
      }

      /* Se avanza por pagina y no por ficha: mover una sola deja al ojo
         buscando donde quedo. Se resta una ficha para que la que estaba
         cortada en el borde quede entera al principio de la vista, que es
         como se lee una tira sin perder el hilo. */
      function page(dir) {
        var first = track.firstElementChild;
        var step = first ? first.getBoundingClientRect().width + 16 : 200;
        var amount = Math.max(step, track.clientWidth - step);
        track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () { page(-1); });
      next.addEventListener('click', function () { page(1); });
      track.addEventListener('scroll', sync, { passive: true });

      if (window.ResizeObserver) {
        new ResizeObserver(sync).observe(track);
      } else {
        window.addEventListener('resize', sync);
      }

      /* Las imagenes son perezosas: hasta que cargan, el ancho del track no
         es el definitivo y las flechas se calcularian sobre una medida que
         va a cambiar. */
      track.querySelectorAll('img').forEach(function (im) {
        if (!im.complete) im.addEventListener('load', sync, { once: true });
      });

      sync();
    });
  }

  /* ------------------------------------------------------------------
     10. Banner carrusel

     La tira ya se desliza sola: el CSS le puso `scroll-snap` y el navegador
     pone el dedo, la rueda y el teclado. Aqui se agregan tres cosas que el
     CSS no puede: las flechas, los puntos y el avance automatico.

     Todo se mueve con `scrollTo`, no cambiando clases: asi el estado real
     es la posicion del scroll, que es la misma que deja el dedo. Con dos
     fuentes de verdad —una clase "activa" y el scroll— alcanza con un
     deslizamiento para que dejen de coincidir.
     ------------------------------------------------------------------ */
  function initPromo(scope) {
    (scope || document).querySelectorAll('[data-promo]').forEach(function (promo) {
      if (promo.dataset.ready) return;
      promo.dataset.ready = '1';

      var track = promo.querySelector('[data-promo-track]');
      if (!track) return;

      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-promo-slide]'));
      if (slides.length < 2) return;

      var prev = promo.querySelector('[data-promo-prev]');
      var next = promo.querySelector('[data-promo-next]');
      var dotsBox = promo.querySelector('[data-promo-dots]');
      var dots = dotsBox ? Array.prototype.slice.call(dotsBox.querySelectorAll('[data-promo-dot]')) : [];

      /* Nacen ocultos en el HTML. Se muestran aqui porque hasta este punto
         no habia nada detras de ellos. */
      [prev, next, dotsBox].forEach(function (el) { if (el) el.hidden = false; });

      function current() {
        /* Redondeo sobre el ancho de la diapositiva. A mitad de un
           desplazamiento la cuenta cae en la mas cercana, que es la que el
           ojo ya considera actual. */
        var w = slides[0].getBoundingClientRect().width || 1;
        var i = Math.round(track.scrollLeft / w);
        return Math.max(0, Math.min(slides.length - 1, i));
      }

      function goTo(i) {
        var w = slides[0].getBoundingClientRect().width || 1;
        track.scrollTo({ left: i * w, behavior: 'smooth' });
      }

      function sync() {
        var i = current();
        dots.forEach(function (d, n) {
          d.setAttribute('aria-current', n === i ? 'true' : 'false');
        });
        /* Sin deshabilitar en los extremos: el banner es circular. Un boton
           apagado en la primera diapositiva sugiere que se acabo algo, y
           aqui no se acaba nada. */
      }

      if (prev) prev.addEventListener('click', function () {
        var i = current();
        goTo(i === 0 ? slides.length - 1 : i - 1);
      });
      if (next) next.addEventListener('click', function () {
        goTo((current() + 1) % slides.length);
      });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { goTo(parseInt(d.dataset.promoDot, 10)); });
      });

      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();

      /* ---- Avance automatico ---------------------------------------- */
      var every = parseInt(promo.dataset.promoAutoplay || '0', 10);
      if (!every) return;

      /* Quien pidio menos animacion en su sistema no quiere que la pagina
         se mueva sola. Es una preferencia declarada, no una suposicion. */
      var quiet = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
      if (quiet && quiet.matches) return;

      var timer = null;
      function play() {
        if (timer) return;
        timer = setInterval(function () { goTo((current() + 1) % slides.length); }, every);
      }
      function pause() {
        clearInterval(timer);
        timer = null;
      }

      promo.addEventListener('mouseenter', pause);
      promo.addEventListener('mouseleave', play);
      /* `focusin` y no `focus`: el foco entra en un enlace de adentro, no
         en el contenedor. Sin esto, quien navega con el teclado ve como el
         banner se lleva de viaje el enlace que estaba leyendo. */
      promo.addEventListener('focusin', pause);
      promo.addEventListener('focusout', function (e) {
        if (!promo.contains(e.relatedTarget)) play();
      });
      /* En otra pestana no hay nadie mirando, y los temporizadores que
         siguen corriendo se acumulan. */
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { pause(); } else { play(); }
      });

      play();
    });
  }

  /* ------------------------------------------------------------------
     Arranque
     ------------------------------------------------------------------ */
  /* ------------------------------------------------------------------
     9. Navegacion movil y desplegables del mega menu

     La hamburguesa venia con `aria-expanded` y `aria-controls` en el HTML
     y ningun manejador detras: por debajo de 900px la barra de categorias
     estaba en `display: none` y no habia forma de llegar a ella. Ocho
     categorias de primer nivel, con todo el catalogo colgando, fuera de
     alcance en telefono.

     El mega menu tenia el mismo problema por otro lado: abria con `:hover`,
     asi que en cualquier pantalla tactil tocar el enlace navegaba y las
     subcategorias no se veian nunca. Por eso cada item con hijos tiene
     ahora su propio boton, en todos los tamanos.
     ------------------------------------------------------------------ */
  function initMobileNav() {
    var header = document.querySelector('.g-header');
    if (!header) return;

    var burger = header.querySelector('.g-burger');
    var nav = header.querySelector('.g-nav');
    var scrim = header.querySelector('[data-nav-scrim]');
    if (!burger || !nav) return;

    // `init` se vuelve a ejecutar en cada `shopify:section:load` del editor.
    // Sin esta marca, cada recarga de seccion sumaria otro par de escuchas
    // en `document` y el mismo Escape cerraria el cajon varias veces.
    if (header.dataset.navReady) return;
    header.dataset.navReady = '1';

    var DRAWER = '(max-width: 900px)';

    function isDrawer() {
      return window.matchMedia(DRAWER).matches;
    }

    function setDrawer(open) {
      nav.toggleAttribute('data-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (scrim) scrim.hidden = !open;
      // El bloqueo del scroll va en el <html>, no en el <body>: en iOS el
      // body con overflow oculto sigue dejando rebotar la pagina de atras.
      document.documentElement.classList.toggle('g-no-scroll', open);
    }

    function closeDrawer(returnFocus) {
      if (!nav.hasAttribute('data-open')) return;
      setDrawer(false);
      if (returnFocus) burger.focus();
    }

    burger.addEventListener('click', function () {
      var open = !nav.hasAttribute('data-open');
      setDrawer(open);
      if (open) {
        var first = nav.querySelector('a, button');
        if (first) first.focus();
      }
    });

    var closeBtn = nav.querySelector('[data-nav-close]');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () { closeDrawer(true); });
    }
    if (scrim) {
      scrim.addEventListener('click', function () { closeDrawer(true); });
    }

    /* Desplegables. Cerrar los hermanos es lo correcto en escritorio, donde
       el panel se superpone al contenido; dentro del cajon se acordeonan y
       tambien conviene, porque ocho paneles abiertos son un scroll infinito. */
    function closeToggles(except) {
      nav.querySelectorAll('[data-nav-toggle][aria-expanded="true"]')
        .forEach(function (btn) {
          if (btn === except) return;
          btn.setAttribute('aria-expanded', 'false');
          btn.closest('[data-nav-item]').removeAttribute('data-open');
        });
    }

    on(nav, '[data-nav-toggle]', 'click', function (e) {
      var btn = e.currentTarget;
      var item = btn.closest('[data-nav-item]');
      var open = btn.getAttribute('aria-expanded') !== 'true';
      closeToggles(btn);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      item.toggleAttribute('data-open', open);
    });

    /* Mientras el cajon esta abierto el resto de la pagina esta detras de un
       telon: si el tabulador sigue recorriendola, el foco se va a enlaces que
       no se ven y quien navega con teclado se pierde. */
    var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (!nav.hasAttribute('data-open') || !isDrawer()) return;

      var items = Array.prototype.filter.call(
        nav.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      } else if (!nav.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      // Si hay un panel abierto, Escape cierra ese primero y deja el cajon:
      // cerrarlo todo de golpe obliga a rehacer la navegacion entera.
      var open = nav.querySelector('[data-nav-toggle][aria-expanded="true"]');
      if (open) {
        closeToggles(null);
        open.focus();
        return;
      }
      closeDrawer(true);
    });

    document.addEventListener('click', function (e) {
      if (header.contains(e.target)) return;
      closeToggles(null);
      closeDrawer(false);
    });

    /* Al pasar de cajon a barra el estado tiene que quedar limpio: un cajon
       abierto que se convierte en barra deja el scroll bloqueado y el telon
       tapando la pagina. */
    var mq = window.matchMedia(DRAWER);
    var onChange = function () {
      if (!isDrawer()) {
        setDrawer(false);
        closeToggles(null);
      }
    };
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  function init(scope) {
    initQuantity(scope);
    initTabs(scope);
    initTierHighlight();
    initGallery(scope);
    initTierShortcut();
    initSpecRows(scope);
    initKeyFacts();
    initViewToggle();
    initBulkSelect();
    initFilters();
    initCajonPedido();
    initAgregarSinSalir();
    initCart();
    initCountdown();
    initOrderDetails();
    initMobileNav();
    initSuggestions(scope);
    initTemplates(scope);
    initTemplateSave(scope);
    initRails(scope);
    initPromo(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // El editor de temas reemplaza secciones sin recargar la página.
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  // Se exporta lo mínimo que otras secciones puedan necesitar.
  window.GlomaxTheme = { addToCart: addToCart, money: money, init: init };

})();
